import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const FormatTextdirectionRToLIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"format_textdirection_r_to_l"} ref={ref}/>
});

FormatTextdirectionRToLIcon.displayName = "FormatTextdirectionRToLIcon";
